module.exports = __webpack_public_path__ + "f7f3cf670e8647dee8c8d26f8477c34a.jpg";